import * as Sentry from '@sentry/react';

interface CaptureOptions {
  tags?: Record<string, string>;
  context?: Record<string, Record<string, unknown>>;
  level?: Sentry.SeverityLevel;
}

export function captureSentryError(error: unknown, feature: string, component: string, options: CaptureOptions = {}) {
  const { tags = {}, context = {}, level = 'error' } = options;

  // eslint-disable-next-line no-console
  console.error(`[${feature}] ${component}`, error, { tags, context });

  Sentry.captureException(error instanceof Error ? error : new Error(`${component}: unexpected error`), {
    level,
    tags: { feature, component, ...tags },
    contexts: {
      ...context,
      ...(!(error instanceof Error) && { originalError: { value: error } }),
    },
  });
}
